import React from 'react';
import './Integrations.css';
import whatsapp from '../assets/images/whatsapp.svg';
import wealth from '../assets/images/wealth-elite-1.webp';
import cloud from '../assets/images/cloud-telephony.webp';
import microsoft from '../assets/images/microsoft-teams-1.webp';
import zoom from '../assets/images/zoom.webp';
import email from '../assets/images/email-intigration.webp';

const integrations = [
  {
    title: 'WhatsApp',
    type: 'whatsapp',
  },
  {
    title: 'Wealth Elite',
    type: 'wealth',
  },
  {
    title: 'Cloud Telephony',
    type: 'cloud',
  },
  {
    title: 'Microsoft Teams',
    type: 'teams',
  },
  {
    title: 'Zoom',
    type: 'zoom',
  },
  {
    title: 'Email Integration',
    type: 'email',
  },
];

const IntegrationIcon = ({ type }) => {
  if (type === 'whatsapp') {
    return (
      <div>
      <img src={whatsapp} alt='Whatsapp' />
      </div>
    );
  }

  if (type === 'wealth') {
    return (
     <div>
      <img src={wealth} alt='wealth' />
     </div>
    );
  }

  if (type === 'cloud') {
    return (
     <div>
      <img src={cloud} alt='cloud' />
     </div>
    );
  }

  if (type === 'teams') {
    return (
     <div>
      <img src={microsoft} alt='microsoft' />
     </div>
    );
  }

  if (type === 'zoom') {
    return (
      <div>
        <img src={zoom} alt='zoom' />
      </div>
    );
  }

  return (
   <div>
    <img src={email} alt='email' />
   </div>
  );
};

const Integrations = () => {
  return (
    <section className="integrations-page" id="upcoming">
      <div className="integrations-container">
        <div className="integrations-left">
          <div className="integrations-kicker">
            <span></span>
            INTEGRATIONS
          </div>

          <h2 className="integrations-title">
            Future-Ready Integrations
            <br />
            Built for <span>MFD Workflows</span>
          </h2>

          <p className="integrations-desc">
            From investor management to communication and calling - Sales Ninja
            integrates seamlessly with your business ecosystem to simplify operations and
            improve productivity.
          </p>

          <ul className="integrations-list">
            <li>Direct Wealth Elite integration for investor & portfolio sync</li>
            <li>Native WhatsApp integration for automated investor communication</li>
            <li>Cloud telephony integration for centralized call tracking & monitoring</li>
            <li>Email integration for campaigns, alerts & investor communication</li>
            <li>Microsoft Teams integration for internal collaboration & productivity</li>
            <li>Zoho CRM integration for connected lead & business workflows</li>
            <li>API-ready architecture for future custom integrations</li>
          </ul>
        </div>

        <div className="integrations-right">
          {integrations.map((item, index) => (
            <div className="integration-card" key={index}>
              <div className={`integration-icon ${item.type}`}>
                <IntegrationIcon type={item.type} />
              </div>
              <h4>{item.title}</h4>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Integrations;